import { Callbacks } from '@cureskin/regimen-sop';
import { ApiConnector, Table } from 'api-client';
import { Injectable } from '@angular/core';

@Injectable( { providedIn: 'root' } )
export class FollowUpSopCallback implements Callbacks {
  async findProductByIdWithInstruction(objectId: string): Promise<any> {
    return JSON.parse(JSON.stringify( await ApiConnector.findOne(Table.Catalog, {
      where: { objectId: objectId },
      include: ['purposeLanguageString',
        'descriptionLanguageString',
        'instructions.frequencyOfApplicationLanguageString' as 'instructions',
        'instructions.frequencyOfApplicationLanguageString' as 'instructions',
        'instructions.areaOfApplicationLanguageString' as 'instructions',
        'instructions.areaOfApplicationLanguageString' as 'instructions',
        'instructions.quantityUnitLanguageString' as 'instructions',
        'instructions.quantityUnitLanguageString' as 'instructions'],
      project: [
        'title',
        'margUnit',
        'quantity',
        'quantityUnit',
        'type',
        'purpose',
        'purposeLanguageString',
        'descriptionLanguageString',
        'instructions'],
    })));
  }
}
